var _rect, _rect2, _rect3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.05469,
    y: 1.17188,
    width: 12.639,
    height: 12.5163,
    rx: 2.25,
    stroke: "#202020",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.9375,
    y: 2.04688,
    width: 10.8716,
    height: 10.7642,
    rx: 1.75,
    stroke: "#EE3124",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.1875,
    y: 1.29688,
    width: 12.3716,
    height: 12.2642,
    rx: 2.5,
    fill: "#E84247"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.60547 5.82286C5.60547 4.50883 6.48916 3.63281 7.37285 3.63281C8.25655 3.63281 9.14024 4.50883 9.14023 5.82286C9.14021 7.13688 8.25655 8.88892 7.37285 8.88892C6.48916 8.88892 5.60547 7.13688 5.60547 5.82286ZM6.48828 10.6416C6.48828 10.1578 6.88392 9.76562 7.37197 9.76562C7.86002 9.76562 8.25566 10.1578 8.25566 10.6416C8.25566 11.1255 7.86002 11.5177 7.37197 11.5177C6.88392 11.5177 6.48828 11.1255 6.48828 10.6416Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/Error.353d2ddcc50238aac83663fbe506bd18.svg";
export { ForwardRef as ReactComponent };